import { Icon } from '@blueprintjs/core';
import React from 'react'

interface IPOSTableProps {
	reportItem: any;
	tableType: "biolng_bunkering_biolng_pos_documents_pos_lng" | "bio_blend_bunkering_bio_blend_pos_documents_pos_volume";
	onClose: () => void;
}

function POSTable(props: IPOSTableProps) {
	const { reportItem, tableType, onClose } = props;

	return (
		<div className='bg-white p-4 pb-8 rounded-lg'>
			{tableType === "biolng_bunkering_biolng_pos_documents_pos_lng" ? (
				<div className='flex flex-col gap-4'>
					<div className='flex justify-between items-center bg-blue-100 p-2 rounded'>
						<h2 className='text-lg font-medium text-blue-500'>POS Documents - POS LNG</h2>
						<button
							className='text-gray-500 hover:text-gray-700 flex items-center'
							onClick={onClose}
						>
							<Icon icon="cross" />
						</button>
					</div>

					<div className='overflow-y-scroll max-h-[80vh]'>
						<table className='w-full border'>
							<thead className='sticky -top-1'>
								<tr>
									<th className='border px-4 py-2 text-left text-gray-800'>POS Number</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Quantity</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Emission Factor</th>
								</tr>
							</thead>
							<tbody>
								{reportItem?.bunker_details?.biolng_bunkering_biolng_pos_documents_pos_lng?.map((bunkerItem: any, index: number) => (
									<tr key={index}>
										<td className='border px-4 py-2 text-gray-700'>{bunkerItem?.pos_number}</td>
										<td className='border px-4 py-2 text-gray-700'>{bunkerItem?.quantity}</td>
										<td className='border px-4 py-2 text-gray-700'>{bunkerItem?.emission_factor}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			) : (
				<div className='flex flex-col gap-4'>
					<div className='flex justify-between items-center bg-blue-100 p-2 rounded'>
						<h2 className='text-lg font-medium text-blue-500'>POS Documents - POS Volume</h2>
						<button
							className='text-gray-500 hover:text-gray-700 flex items-center'
							onClick={onClose}
						>
							<Icon icon="cross" />
						</button>
					</div>
					<div className='overflow-y-scroll max-h-[80vh]'>
						<table className='min-w-full border'>
							<thead className='sticky -top-1'>
								<tr>
									<th className='border px-4 py-2 text-left text-gray-800'>POS Number</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Volume</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Density</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Energy Content</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Emission Factor</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Bio Type</th>
								</tr>
							</thead>
							<tbody>
								{reportItem?.bunker_details?.bio_blend_bunkering_bio_blend_pos_documents_pos_volume?.map((bunkerItem: any, index: number) => (
									<tr key={index}>
										<td className='border px-4 py-2'>{bunkerItem?.pos_number}</td>
										<td className='border px-4 py-2'>{bunkerItem?.volume}</td>
										<td className='border px-4 py-2'>{bunkerItem?.density}</td>
										<td className='border px-4 py-2'>{bunkerItem?.energy_content}</td>
										<td className='border px-4 py-2'>{bunkerItem?.emission_factor}</td>
										<td className='border px-4 py-2'>{bunkerItem?.bio_type}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					<div className='flex justify-between items-center bg-blue-100 p-2 rounded'>
						<h2 className='text-lg font-medium text-blue-500'>POS Documents - POS Mass</h2>
					</div>
					<div className='overflow-y-scroll max-h-[80vh]'>
						<table className='min-w-full border'>
							<thead className='sticky -top-1'>
								<tr>
									<th className='border px-4 py-2 text-left text-gray-800'>POS Number</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Mass</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Energy Content</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Emission Factor</th>
									<th className='border px-4 py-2 text-left text-gray-800'>Bio Type</th>
								</tr>
							</thead>
							<tbody>
								{reportItem?.bunker_details?.bio_blend_bunkering_bio_blend_pos_documents_pos_mass?.map((bunkerItem: any, index: number) => (
									<tr key={index}>
										<td className='border px-4 py-2'>{bunkerItem?.pos_number}</td>
										<td className='border px-4 py-2'>{bunkerItem?.mass}</td>
										<td className='border px-4 py-2'>{bunkerItem?.energy_content}</td>
										<td className='border px-4 py-2'>{bunkerItem?.emission_factor}</td>
										<td className='border px-4 py-2'>{bunkerItem?.bio_type}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			)}
		</div>
	)
}

export default POSTable